import { render, staticRenderFns } from "./detailClient.vue?vue&type=template&id=43ac320e"
import script from "./detailClient.vue?vue&type=script&lang=js"
export * from "./detailClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports